<style scoped>

  #sucess{
    width: 1190px;
    height: 300px;
    padding-top: 58px;

  }
  #sucess .top{
    padding-bottom: 46px;
    font-size: 24px;
    color: #FF0000;
    padding-left: 50px;
  }
  #sucess .bottom{
    padding-left: 75px;
    font-size: 20px;
    padding-bottom: 50px;
  }
  #btm{
    width: 200px;
    height:40px;
    background: #141651;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    cursor: pointer;
    font-size: 16px;
  }

</style>

<template>
    <div id="sucess">
      <div class="top"><Icon type="checkmark-round"></Icon> Success</div>
      <div class="bottom">Your abstract is submitted successfully</div>
      <div id="btm" @click="next()">Check &nbsp;&nbsp;status</div>

    </div>
</template>

<script>
  import  'iview/src/styles/common/iconfont/fonts/ionicons.eot'
  import 'iview/src/styles/common/iconfont/fonts/ionicons.svg'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.ttf'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.woff'
    export default{
        data(){
            return {}
        },
        mounted(){

        },
        methods: {
            next(){
              this.$router.push('/home_en/2006/abstract/status');
            }
        }

    }

</script>



// WEBPACK FOOTER //
// Success.vue?37a89498